import { useAuth0 } from '@auth0/auth0-react';

const AuthenticationButton = () => {
    const { user } = useAuth0();
    return user ? user.email : 'Anonymous'
};

export default AuthenticationButton;